export default __webpack_public_path__ + "static/media/logo_orange.9896fc2a.svg";